// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".inbox-container[data-v-5b7562e2]{background-color:var(--v-background-base,#f5f5f5)}.theme--dark .inbox-container[data-v-5b7562e2]{background-color:#121212!important}.credit-img[data-v-5b7562e2]{max-width:1.5rem;height:auto}.custom-color[data-v-5b7562e2]{color:#fff;font-weight:600;font-size:1.2rem}.fb-button[data-v-5b7562e2]{color:#fff}.intframe[data-v-5b7562e2]{height:100vh;width:100%}", ""]);
// Exports
module.exports = exports;
